import React, { Component } from 'react';
import config from 'react-global-configuration';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


class StaffDebtPayments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      payment_date: '',
      id: this.props.staff_debt_payment_id,
      staff_debt_payments: [],
      modal: false,
    };

    this.debtLabel = this.debtLabel.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined' && typeof newProps.staff_debt_payment_id !== 'undefined') {
      this.setState({
        id: newProps.staff_debt_payment_id,
      });
    }
    if(Array.isArray(newProps.staff_debt_payments)) {
      this.setState({staff_debt_payments: newProps.staff_debt_payments});
    }
  }
  
  debtLabel (cell, row) {
    var botao = '';
    if (cell === 1) {
      botao = <p className="text-danger"><i className="fa fa-fw fa-warning"></i></p>;
    }

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  <hr/>
  <BootstrapTable data={this.state.staff_debt_payments} pagination={true} striped={true} hover={true} options={{noDataText: 'Não há pagamentos em aberto'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
    <TableHeaderColumn dataField="debt" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60' dataFormat={this.debtLabel}>Saldo</TableHeaderColumn>
    <TableHeaderColumn dataField="staff" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
    <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Período</TableHeaderColumn>
    <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>
    <TableHeaderColumn dataField="training_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nº e Rev.</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_paid" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Diárias</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Valor/diária</TableHeaderColumn>
    <TableHeaderColumn dataField="debt_charge" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Desconto</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_total" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Total em diárias</TableHeaderColumn>
    <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Moeda</TableHeaderColumn>
  </BootstrapTable>
</div>
    );
  }
}

export default StaffDebtPayments;



// WEBPACK FOOTER //
// ./src/Components/TrainingCertificationStaffPayments/Elements/StaffDebtPayments.js